import React, {useState} from "react";
import {Alert, Dialog, DialogActions, DialogContent, DialogTitle, Grid2} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CustomTextField from "../../../../../components/customMUIComponents/CustomTextField";
import useDataPost from "../../../../../hooks/useDataPost";


interface UpdateMailModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
}

const UpdateMailModal = ({open, setOpen}: UpdateMailModalProps) => {

    const [password, setPassword] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [emailConfirmation, setEmailConfirmation] = useState<string>('');

    const [error, setError] = useState<string>();

    const {postDataPromise} = useDataPost<void>(`/update-mail`, {}, true, false, false);

    const handleCloseModal = () => {
        setOpen(false);
    }

    const handleUpdate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        if (email !== emailConfirmation) {
            setError('Les adresses email ne correspondent pas.');
            return;
        }
        postDataPromise(undefined, {
            newEmail: email,
            password: password,
        }).then((response) => {
            window.location.href = window.location.href + '?mailUpdated=true';
        }).catch((reason) => {
            setError("Mot de passe incorrect")
        })
    }

    return (
        <>
            <form onSubmit={(e) => handleUpdate(e)}>
                <Dialog
                    disablePortal
                    open={open}
                    onClose={() => setOpen(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <DialogTitle>
                        <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                            Modifier l'adresse email
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{
                        minWidth: '300px'
                    }}>
                        <Grid2 container>
                            <CustomTextField
                                value={email}
                                label="Nouvelle adresse email"
                                mb={4}
                                mt={2}
                                type="email"
                                required
                                setField={setEmail}
                                variant="outlined"
                            />
                            <CustomTextField
                                value={emailConfirmation}
                                label="Confirmation email"
                                mb={4}
                                type="email"
                                required
                                setField={setEmailConfirmation}
                                variant="outlined"
                            />
                            <CustomTextField
                                value={password}
                                label="Mot de passe"
                                mb={4}
                                type="password"
                                required
                                setField={setPassword}
                                variant="outlined"
                            />
                        </Grid2>
                        {error && (
                            <Alert
                                severity="error"
                                sx={{mb: 4}}
                            >
                                {error}
                            </Alert>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type={"submit"}
                        >
                            Modifier l'adresse
                        </Button>
                        <Button onClick={() => handleCloseModal()}>Fermer</Button>
                    </DialogActions>
                </Dialog>
            </form>
        </>
    );
}

export default UpdateMailModal